import {Model} from "./";
import {Api} from "../api";

class PaymentModel extends Model {

    constructor() {
        super(new Api("/payment"));
    }

    getTypes(clientId,thenFunction, errorFunction) {
        this.q.setDopUrl('/types/'+clientId);
        this.q.read({}, thenFunction, errorFunction);
    }

    getPayments(deliveryType,thenFunction, errorFunction) {
        this.q.setDopUrl('/option/'+deliveryType);
        this.q.read({}, thenFunction, errorFunction);
    }

    getDiscounts(clientId,thenFunction, errorFunction) {
        this.q.setDopUrl('/discounts/'+clientId);
        this.q.read({}, thenFunction, errorFunction);
    }

}

export default new PaymentModel();